import React from 'react';
import classes from './index.module.css';

const UnTouchLayer = ({ children, touch }) => (
  <div className={touch ? classes.UnTouch : classes.Touch}>{children}</div>
);
export default UnTouchLayer;
